<template>
    <div>
        <FormControl
            label="Type"
            required
        >
            <div class="space-y-1">
                <RadioInput
                    label="Integer"
                    :value="CustomFieldNumberTypeEnum.Integer"
                    :checked="
                        localSettings?.data.numberType ===
                        CustomFieldNumberTypeEnum.Integer
                    "
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Number}][${CustomFieldSettingsKeysEnum.Number_Type}]`"
                    v-model="dummySelectedType"
                    required
                />
                <RadioInput
                    label="Decimal"
                    :value="CustomFieldNumberTypeEnum.Decimal"
                    :checked="
                        localSettings?.data.numberType ===
                        CustomFieldNumberTypeEnum.Decimal
                    "
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Number}][${CustomFieldSettingsKeysEnum.Number_Type}]`"
                    v-model="dummySelectedType"
                    required
                />
            </div>
        </FormControl>
        <FormControl label="Minimum value">
            <TextInput
                :value="localSettings?.data.numberMinValue"
                :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Number}][${CustomFieldSettingsKeysEnum.Number_MinValue}]`"
            />
        </FormControl>
        <FormControl label="Maximun value">
            <TextInput
                :value="localSettings?.data.numberMaxValue"
                :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Number}][${CustomFieldSettingsKeysEnum.Number_MaxValue}]`"
            />
        </FormControl>
        <template
            v-if="dummySelectedType === CustomFieldNumberTypeEnum.Decimal"
        >
            <FormControl label="Number of decimal places">
                <TextInput
                    :value="localSettings?.data.numberDecimalPlaces"
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Number}][${CustomFieldSettingsKeysEnum.Number_DecimalPlaces}]`"
                />
            </FormControl>
        </template>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import {
        CustomFieldNumberTypeEnum,
        CustomFieldSettingsKeysEnum,
        CustomFieldTypeEnum,
        type CustomFieldSettingsNumberType,
    } from '@/Shared/AutoGenerated/Main'
    import RadioInput from '@/Shared/Component/Forms/RadioInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField | null>,
            default: null,
        },
    })

    const localSettings: CustomFieldSettingsNumberType | null =
        props.customField?.settings
    const dummySelectedType = ref<string | null>(null)
</script>
